const connections = require('../connections');
const apVersion = '/v1';

// setting for api proxy
const apiProxyConfig = {
  apiKey: 'CE2AED7B893CEC8476FE17A570E61366',
  proxy: 'WEh2WJDzGZV9UgcIt0BS0y5HGsK2',
  introspection: true
};

const externalIP = 'https://api.xliberation.com'
const internalService = 'http://fid-app-dbp-elp-psp-svc.default:80'
// to minimize the number of pods used during testing period I'm allowing the main api to do proxying as well

const apConfig = apiProxyConfig
/* to disable proxy for this instance use this instead of apiProxyConfig
{
  apiKey: 'b1209e8561732224e00aa9cede420d09',
  introspection: false
}
*/
const alConfig = {
  apiKey: 'b1209e8561732224e00aa9cede420d09',
  introspection: true
}
// TODO - find out how to make an internal http ingress
// for now just point internal to the ingress too
const externals = {
  // cant connect to dev from external
  d: null,
  p: `${externalIP}${apVersion}`
  // this is the ingress for the api on kubernetes
  /*
  x: `https://apx.fid.mcpher.tech${apVersion}`,
  p: `https://app.fid.mcpher.tech${apVersion}`
  */
};
const internals = {
  m: `http://fid-api:8011${apVersion}`,
  d: `http://host.docker.internal:8011${apVersion}`,
  local: `http://localhost:8011${apVersion}`,
  p: `${internalService}${apVersion}`
};



const cobs = {
  apd: {
    ingress: {
      internal: internals.local,
      external: internals.d
    },
    redirectHost: internals.local,
    options: apiProxyConfig,
  },
  apm: {
    ingress: {
      internal: internals.m,
      external: internals.m   // same platform → internal used
    },
    redirectHost: internals.m,
    options: apiProxyConfig,
  },
  apl: {
    ingress: {
      external: externals.l,
      internal: internals.l
    },
    options: alConfig,
    redirectHost: externals.l,
  },
  apx: {
    options: apiProxyConfig,
    ingress: {
      external: externals.x,
      internal: internals.x
    },
    redirectHost: externals.x,
  },
  app: {
    options: apConfig,
    ingress: {
      external: externals.p,
      internal: internals.p
    },
    redirectHost: externals.p,
  }
}
const profile =   {
  version: '0.7.0.a-0',
  // this will cause keys to be digested differently for things that might affect cache
  cacheBuild: 28,
  // this isnt used any longer - but the idea is if persistent redis stuff is needed, this can be used to provoke a rebuild
  authCacheBuild: 3,
  // this should be updated when a schema is revised - the last digit always increases
  schemaVersion: '0.6.0',
  released: new Date(2026, 5, 24)
};


// this is the only exposed thing
const getConnection = ({ modes, log }) => {

  const connectionType = 'ap';
  // standard checking that we are connecting to the right thing
  const {
    howToConnect,
    mode
  } = connections.checkConnection({ modes, log, connectionType });

  // connection object specific to this type
  const targetMode = cobs[mode];

  // in this case we need to construct a service name based on the target connection combination, if its not fixed
  const ingress = targetMode.ingress || {};

  // the service is based on all the other info for internal connections on kube
  // see https://github.com/filmid/fidmaster/issues/199 for why this doesn't work
  const svc = 'http://fid-' + modes.connectionId.replace(/[^:]+:/, '') + '-svc:80';
  const host = howToConnect.needIngress ? ingress.external : (ingress.internal || svc);
  const redirectHost = targetMode.redirectHost
  console.log('....host for api is', host)
  console.log('....redirect host for api is', redirectHost)
  // need ingress determines whether we are on the same network
  // - if not we need to use the
  // external connection

  return {
    needIngress: howToConnect.needIngress,
    host,
    options: targetMode.options,
    howToConnect,
    mode,
    profile,
    apVersion,
    redirectHost
  }
}
module.exports = {
  getConnection
};